// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__3w7V8","Loader__fill":"Loader_Loader__fill__1vmvD","slide":"Loader_slide__Bd1IP"};